import { colors } from "../../data/Colors";
import _ from "lodash";

const r1 = {
  left: -4,
  right: 4,
  top: -8,
  bottom: 8,
  skewX: 1,
  skewY: -4
};

const sizeTable = {
  strokeSize: [2, 2, 8, 14],
  stroke: 4,
  w: 7,
  h: 12,
  rect: {
    tl: { x: r1.left + r1.skewX, y: r1.top + r1.skewY },
    tr: { x: r1.right + r1.skewX, y: r1.top - r1.skewY },
    bl: { x: r1.left + r1.skewX, y: r1.bottom + r1.skewY },
    br: { x: r1.right + r1.skewX, y: r1.bottom - r1.skewY }
  }
};

// 14 x 24px roundあり
export default class Marker {
  constructor() {}
  draw(context, lastPos, pos, color, size, scale = 1) {
    this.setColors(context, color, size);
    context.beginPath();

    // this.simpleLine(context, lastPos, pos);
    // this.rectLine(context, lastPos, pos, size);
    // this.rectLine2(context, lastPos, pos, size);
    this.rectLine3(context, lastPos, pos, size, scale);
  }

  setColors(context, color, size) {
    let c = colors[color];
    context.strokeStyle = c;
    context.lineJoin = "round";
    context.lineWidth = sizeTable.strokeSize[size];
    // context.lineWidth = sizeTable.stroke * sizeTable.size[size];
    context.fillStyle = c;
  }

  simpleLine(context, lastPos, pos) {
    // 描画開始座標を指定する
    context.moveTo(lastPos.x, lastPos.y);

    // 描画開始座標から、lineToに指定された座標まで描画する
    context.lineTo(pos.x, pos.y);

    context.closePath();
    context.stroke();
  }

  rectLine(context, lastPos, pos, size) {
    const w = sizeTable.w * size;
    const h = sizeTable.h * size;
    const r = { l: -w, r: w, t: -h, b: h };
    const lastRect = {
      l: lastPos.x + r.l,
      r: lastPos.x + r.r,
      t: lastPos.y + r.t,
      b: lastPos.y + r.b
    };
    const newRect = {
      l: pos.x + r.l,
      r: pos.x + r.r,
      t: pos.y + r.t,
      b: pos.y + r.b
    };

    // 中央の辺
    context.moveTo(lastRect.l, lastPos.y);
    context.lineTo(lastRect.r, lastPos.y);
    context.lineTo(newRect.r, pos.y);
    context.lineTo(newRect.l, pos.y);
    context.lineTo(lastRect.l, lastPos.y);
    context.closePath();
    context.fill();
    context.stroke();
  }

  /**
   * シンプルマーカー。長方形をそのまま使用。
   * @param context
   * @param lastPos
   * @param pos
   * @param size
   */
  rectLine2(context, lastPos, pos, size) {
    const lastRect = this.calcRect(lastPos);
    const newRect = this.calcRect(pos);

    //上辺
    context.moveTo(lastRect.tl.x, lastRect.tl.y);
    context.lineTo(lastRect.tr.x, lastRect.tr.y);
    context.lineTo(newRect.tr.x, newRect.tr.y);
    context.lineTo(newRect.tl.x, newRect.tl.y);
    // context.lineTo(lastRect.l, lastRect.t);
    context.closePath();
    context.fill();

    // //下辺
    context.moveTo(lastRect.bl.x, lastRect.bl.y);
    context.lineTo(lastRect.br.x, lastRect.br.y);
    context.lineTo(newRect.br.x, newRect.br.y);
    context.lineTo(newRect.bl.x, newRect.bl.y);
    context.closePath();
    context.fill();
    //
    // //左辺
    context.moveTo(lastRect.tl.x, lastRect.tl.y);
    context.lineTo(lastRect.bl.x, lastRect.bl.y);
    context.lineTo(newRect.bl.x, newRect.bl.y);
    context.lineTo(newRect.bl.x, newRect.tl.y);
    // context.lineTo(lastRect.l, lastRect.t);
    context.closePath();
    context.fill();
    // // 右辺
    context.moveTo(lastRect.tr.x, lastRect.tr.y);
    context.lineTo(lastRect.br.x, lastRect.br.y);
    context.lineTo(newRect.br.x, newRect.br.y);
    context.lineTo(newRect.tr.x, newRect.tr.y);
    // context.lineTo(lastRect.r, lastRect.t);
    context.closePath();
    context.fill();
    //
    // // 真ん中
    // context.moveTo(newRect.l, newRect.t);
    // context.lineTo(newRect.l, newRect.b);
    // context.lineTo(newRect.r, newRect.b);
    // context.lineTo(newRect.r, newRect.t);

    // 中央の辺
    context.moveTo(lastRect.tl.x, lastRect.tl.y);
    context.lineTo(lastRect.tr.x, lastRect.tr.y);
    context.lineTo(newRect.br.x, newRect.br.y);
    context.lineTo(newRect.bl.x, newRect.bl.y);
    context.lineTo(lastRect.tl.x, lastRect.tl.y);
    context.closePath();
    context.fill();
    // context.stroke();
  }
  rectLine3(context, lastPos, pos, size, scale = 1) {
    size--;
    const sizeAmp = [0.5, 0.65, 0.8];
    const lastRect = this.calcRect2(lastPos, sizeAmp[size] * scale);
    const newRect = this.calcRect2(pos, sizeAmp[size] * scale);

    //上辺
    context.moveTo(lastRect.tl.x, lastRect.tl.y);
    context.lineTo(lastRect.tr.x, lastRect.tr.y);
    context.lineTo(newRect.tr.x, newRect.tr.y);
    context.lineTo(newRect.tl.x, newRect.tl.y);
    // context.lineTo(lastRect.l, lastRect.t);
    context.closePath();
    context.fill();
    context.strokeSize = 4;
    context.stroke();
  }
  rectLine4(context, lastPos, pos, size) {
    const lastRect = this.calcRect(lastPos);
    const newRect = this.calcRect(pos);

    //上辺
    context.moveTo(
      (lastRect.tl.x + newRect.tl.x) * 0.5,
      (lastRect.tl.y + newRect.tl.y) * 0.5
    );
    context.lineTo(
      (lastRect.tr.x + newRect.tr.x) * 0.5,
      (lastRect.tr.y + newRect.tr.y) * 0.5
    );
    context.lineTo(
      (lastRect.br.x + newRect.br.x) * 0.5,
      (lastRect.br.y + newRect.br.y) * 0.5
    );
    context.lineTo(
      (lastRect.bl.x + newRect.bl.x) * 0.5,
      (lastRect.bl.y + newRect.bl.y) * 0.5
    );
    context.closePath();
    context.fill();
    // context.stroke();
  }

  calcRect(pos) {
    const rect = this.cloneDeep(sizeTable.rect);
    rect.tl.x += pos.x;
    rect.tr.x += pos.x;
    rect.bl.x += pos.x;
    rect.br.x += pos.x;

    rect.tl.y += pos.y;
    rect.tr.y += pos.y;
    rect.bl.y += pos.y;
    rect.br.y += pos.y;

    return rect;
  }
  calcRect2(pos, sizeAmp = 1) {
    const rect = this.cloneDeep(sizeTable.rect);
    rect.tl.y -= r1.top;
    rect.tr.y -= r1.top;

    rect.tl.x *= sizeAmp;
    rect.tr.x *= sizeAmp;
    rect.tl.y *= sizeAmp;
    rect.tr.y *= sizeAmp;

    rect.tl.x += pos.x;
    rect.tr.x += pos.x;

    rect.tl.y += pos.y;
    rect.tr.y += pos.y;

    return rect;
  }
  cloneDeep(rect) {
    // lodashのcloneDeepがめっちゃ遅い
    return {
      tl: { x: rect.tl.x, y: rect.tl.y },
      tr: { x: rect.tr.x, y: rect.tr.y },
      bl: { x: rect.bl.x, y: rect.bl.y },
      br: { x: rect.br.x, y: rect.br.y }
    };
  }
}
